import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../firebase'; // Import db
import { doc, onSnapshot } from 'firebase/firestore'; // Import Firestore functions
import React, { useEffect, useState } from 'react';

const AuthContext = React.createContext();

export function useAuth() {
    return React.useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [userLoggedIn, setUserLoggedIn] = useState(false);

    useEffect(() => {
        console.log("Setting up Firebase Auth listener...");

        let unsubscribeFirestore = null;

        const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
            console.log("Auth state changed:", user ? "User logged in" : "User logged out");

            if (user) {
                // User is signed in, listen to Firestore changes
                setUserLoggedIn(true); // Optimistic update

                const userRef = doc(db, "users", user.uid);
                unsubscribeFirestore = onSnapshot(userRef, (docSnap) => {
                    if (docSnap.exists()) {
                        const userData = docSnap.data();
                        // console.log("Updated user data from Firestore:", userData); // Silenced for production
                        setCurrentUser({ ...user, ...userData }); // Merge Auth + Firestore
                    } else {
                        // If no firestore doc, just use auth user
                        setCurrentUser({ ...user });
                    }
                    setLoading(false);
                }, (error) => {
                    console.error("Firestore Error:", error);
                    setCurrentUser({ ...user }); // Fallback
                    setLoading(false);
                });

            } else {
                // User is signed out
                if (unsubscribeFirestore) unsubscribeFirestore();
                setCurrentUser(null);
                setUserLoggedIn(false);
                setLoading(false);
            }
        });

        // Cleanup
        return () => {
            console.log("Cleaning up Firebase Auth listener");
            unsubscribeAuth();
            if (unsubscribeFirestore) unsubscribeFirestore();
        };
    }, []);

    const value = {
        currentUser,
        userLoggedIn,
        loading
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}